import {
  init_vertexColorMixing
} from "./chunk-QNLPC2C5.mjs";
import {
  init_fogVertex
} from "./chunk-56MFY56D.mjs";
import {
  init_fogVertexDeclaration
} from "./chunk-AOP4QQ6I.mjs";
import {
  init_instancesDeclaration
} from "./chunk-S2QACKYP.mjs";
import {
  init_bakedVertexAnimation,
  init_bakedVertexAnimationDeclaration
} from "./chunk-BVXC3PX6.mjs";
import {
  init_instancesVertex
} from "./chunk-QTN4RCMJ.mjs";
import {
  init_bonesVertex
} from "./chunk-RNSXW2BB.mjs";
import {
  init_clipPlaneVertex
} from "./chunk-6WC7OF4Z.mjs";
import {
  init_bonesDeclaration
} from "./chunk-F3QSZLQN.mjs";
import {
  init_clipPlaneVertexDeclaration
} from "./chunk-STSH6UFH.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/color.vertex.js
var name, shader, colorVertexShaderWGSL;
var init_color_vertex = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/color.vertex.js"() {
    init_shaderStore();
    init_bonesDeclaration();
    init_bakedVertexAnimationDeclaration();
    init_clipPlaneVertexDeclaration();
    init_fogVertexDeclaration();
    init_instancesDeclaration();
    init_instancesVertex();
    init_bonesVertex();
    init_bakedVertexAnimation();
    init_clipPlaneVertex();
    init_fogVertex();
    init_vertexColorMixing();
    name = "colorVertexShader";
    shader = `attribute position: vec3f;
#ifdef VERTEXCOLOR
attribute color: vec4f;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#ifdef FOG
uniform view: mat4x4f;
#endif
#include<instancesDeclaration>
uniform viewProjection: mat4x4f;
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vColor: vec4f;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
@vertex
fn main(input : VertexInputs)->FragmentInputs {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
var worldPos: vec4f=finalWorld* vec4f(input.position,1.0);vertexOutputs.position=uniforms.viewProjection*worldPos;
#include<clipPlaneVertex>
#include<fogVertex>
#include<vertexColorMixing>
#define CUSTOM_VERTEX_MAIN_END
}`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    colorVertexShaderWGSL = { name, shader };
  }
});

export {
  colorVertexShaderWGSL,
  init_color_vertex
};
